export default __webpack_public_path__ + "static/media/section1-slide-A1.802d2100.jpg";